import React from 'react';
import styles from './TutorialPopup.module.css';
// Removed incorrect image import

const TutorialPopup = ({ onClose }) => {
  const handleUnderstand = () => {
    localStorage.removeItem('pendingTutorial');
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        {/* Add the image separately */}
        <img src={`${process.env.PUBLIC_URL}/converting_image.webp`} alt="Book Processing Mascot" className={styles.popupImage} />
        <div className={styles.popupContent}> {/* New container for text */}
          <h3>Your audiobook is being created</h3>
          <p>Sit back. Here's what to expect:</p>
          <ul className={styles.popupList}>
            <li>Larger books take longer, but you can start listening as soon as the first chapters are ready.</li>
            <li>It may briefly disappear from your library while it finishes, then reappear. That's normal.</li>
            <li>We'll email you the moment it's done.</li>
          </ul>
          <button className={styles.understandButton} onClick={handleUnderstand}>
            I understand
          </button>
        </div> {/* End new container */}
      </div>
      </div>
    );
  };
  
  export default TutorialPopup;